import React, { useState } from "react";
import Slider from "react-slick";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./AllCategories.css";

// ✅ Import images
import home1 from "./assets/images/home1.avif";
import home2 from "./assets/images/home2.avif";
import home3 from "./assets/images/home3.avif";

export default function AllCategories() {
  const singleSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="container-fluid my-4 mt-5 px-3">
      {/* 🔹 Spotlight Slider */}
      <h4 className="card-title fw-bold mb-3 text-danger ms-2">
        Category Details
      </h4>
      <Slider {...singleSlider} className="mb-4">
        {[home1, home2, home3].map((img, i) => (
          <div
            key={i}
            style={{
              height: "60px",            // 🔹 Reduced height
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <img
              src={img}
              alt={`spotlight-${i}`}
              style={{
                width: "100%",          // full width
                height: "auto",         // maintain aspect ratio
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
